<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      width="625"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id.length > 0 ? 'Ubah Data' : 'Tambah' }} Pengumuman
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4" :class="form.id.length < 1 ? 'mt-3' : 'my-3'"/>

        <div class="px-5 mb-3" v-if="form.id.length < 1">
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#00ACC1"
            dense
            grow
            class="d-flex justify-start">
            <v-tab
              v-for="(item, index) in menu"
              :key="index"
              class="px-0 mx-1"
              :style="index < 1 ? 'min-width: 35px; max-width: 35px;' : 'min-width: 60px; max-width: 60px;'">
              <span class="body-2 text-capitalize" :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item }}
              </span>
            </v-tab>
          </v-tabs>
        </div>

        <v-card-text class="pt-2" style="height: 500px;">
          <ValidationObserver ref="form">
            <v-form>
              <v-card flat v-if="selected.menu < 1">
                <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Judul
                  </p>

                  <v-text-field
                    v-on:keyup.enter="save()"
                    :style="rps === 'xs' ? '' : 'width: 70%;'"
                    dense
                    outlined
                    placeholder="Ex. Rapat Akhir Tahun"
                    color="#00ACC1"
                    v-model="form.title"
                    :error-messages="errors"
                    require>
                  </v-text-field>
                </ValidationProvider>

                <ValidationProvider name="desc" rules="required" v-slot="{ errors }">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Keterangan
                  </p>

                  <v-textarea
                    v-on:keyup.enter="save()"
                    outlined
                    dense
                    placeholder="Ex. Besok masuk ada rapat akhir tahun, terima kasih."
                    rows="10"
                    color="#00ACC1"
                    v-model="form.desc"
                    :error-messages="errors"
                    require>
                  </v-textarea>
                </ValidationProvider>

                <v-checkbox 
                  v-model="form.template_bool" 
                  color="#00ACC1" 
                  :false-value="false" 
                  :true-value="true"
                  dense
                  hide-details>
                  <template v-slot:label>
                    <span class="text-first">
                      Jadikan Template?
                    </span>
                  </template>
                </v-checkbox>
              </v-card>

              <v-card flat v-else>
                <v-skeleton-loader
                  v-for="(item, index) in process.template ? 5 : list.template"
                  :key="index"
                  class="ma-auto"
                  :loading="process.template"
                  type="article">
                  <v-list dense class="pa-0">
                    <v-list-item @click="selected.template = index; takeTemplate();">
                      <v-list-item-icon class="mr-4">
                        <v-icon
                          :color="selected.template === index ? '#00ACC1' : ''">
                          {{
                            selected.template !== index ? 'mdi-checkbox-blank-circle-outline' : 'mdi-checkbox-marked-circle'
                          }}
                        </v-icon>
                      </v-list-item-icon>
                      
                      <v-list-item-content>
                        <p class="body-1 font-weight-bold mb-2">
                          {{ item.title }}
                        </p>

                        <p class="body-2 font-weight-light mb-0">
                          {{ item.desc }}
                        </p>

                        <v-divider class="mt-4" v-if="index < list.template.length - 1"/>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-skeleton-loader>

                <empty v-if="!process.template && pagination.template.total_page < 1"
                  margin="mt-16"
                  size="125"
                  message="Template"/>
              </v-card>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <pagination v-if="pagination.template.total_data > 1 && selected.menu > 0"
          @changePage="fetchTemplate($event)" 
          @reloadPage="fetch($event)"
          :model="pagination.template"
          flex="center"
          padding="py-0"/>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Hapus Data Pengumuman
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="body-1 font-weight-light text-first mt-4">
          Apakah anda yakin menghapus data pengumuman yang anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-row>
      <v-col cols="12">
        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="9" class="d-flex align-center">
                <div>
                  <v-btn
                    elevation="0"
                    style="background: #00acc133;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                    @click="reset()">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #2196f333;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="reset(selected.row[0])">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length > 0">
                  <v-btn
                    elevation="0"
                    style="background: #f4403433;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.title"
                  @click:clear="search.title = ''; fetch();"
                  v-on:keyup.enter="fetch()">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid text-capitalize"
            :height="`calc(100vh - ${pagination.data.total_data > 0 ? '300px' : '228px'})`"
            fixed-header
            show-select
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="headers"
            :items="list.data"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.input_datetime`]="{ item }">
              {{ item.input_datetime | datetime }}
            </template>

            <template v-slot:[`item.template_bool`]="{ item }">
              <span class="font-weight-bold"
                :class="item.template_bool ? 'cyan--text text-darken-1' : 'text-second'">
                {{ item.template_bool ? 'Ya' : 'Tidak' }}
              </span>
            </template>
          </v-data-table>

          <pagination v-if="pagination.data.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)"
            :model="pagination.data"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          delete: false,
          snackbar: false
        },
        search: {
          title: ''
        },
        selected: {
          menu: 0,
          template: 0,
          row: [],
          delete: []
        },
        menu: ['Baru', 'Template'],
        options: {},
        headers: [],
        list: {
          data: [],
          template: []
        },
        pagination: {
          data: {},
          template: {}
        },
        limit: 20,
        form: {
          id: '',
          title: '',
          desc: '',
          template_bool: false
        },
        process: {
          load: false,
          form: false,
          template: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      empty: () => import(/* webpackPrefetch: true */ '@/components/empty.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      'selected.menu': function(val) {
        this.form = {
          id: '',
          title: '',
          desc: '',
          template_bool: false
        }
        
        if (val > 0) this.fetchTemplate()
      },
      options: {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      async fetch(pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.title
        }

        await get(`admin/announcement`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.headers = [
              {
                text: 'Judul',
                width: '200px',
                value: 'title'
              },
              {
                text: 'Keterangan',
                width: '500px',
                value: 'desc'
              },
              {
                text: 'Tanggal',
                width: '120px',
                value: 'input_datetime'
              },
              {
                text: 'Template',
                width: '100px',
                value: 'template_bool'
              }
            ]
            
            this.list.data = res.results.data
            this.pagination.data = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      async fetchTemplate(pagination = { row: 20, page: 1 }) {
        this.process.template = true

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort:'-id',
          template_bool: true
        }

        await get(`admin/announcement`, { params }).then(response => {
          let res = response.data

          this.process.template = false

          if (res.status === 200) {
            this.list.template = res.results.data
            this.pagination.template = res.results.pagination

            this.selected.template = 0

            this.takeTemplate()
          }
        })
      },
      reset(item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = !this.dialog.form ? true : false

        this.selected.menu = 0

        this.form = {
          id: item === undefined ? '' : item.id,
          title: item === undefined ? '' : item.title,
          desc: item === undefined ? '' : item.desc,
          template_bool: item === undefined ? false : item.template_bool
        }

        this.process.form = false

        this.message.error = ''
      },
      takeTemplate() {
        this.form = {
          id: '',
          title: this.list.template[this.selected.template].title,
          desc: this.list.template[this.selected.template].desc,
          template_bool: false
        }
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let url = this.form.id.length < 1 ? `admin/announcement/add` : `admin/announcement/update`
          
          this.process.form = true
          
          await post(url, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.selected.menu = 0

              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      toDelete() {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes() {
        this.message.error = ''

        this.process.form = true

        await post(`admin/announcement/deletes`, {
          data: {
            id_array: this.selected.delete
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>